import services from "../services/api";

const api = services.apiV1

const VehicleRepository = {
  async getVehicleData(licensePlate) {
    const data = await api.get(`vehicles/search/plate/${licensePlate}`);
    return data?.data || null;
  },

  async createVehicle(body) {
    const { data } = await api.post(`vehicles/`, body);
    return data
  }
};

export default VehicleRepository;
